<template>
  <span :class="rootClass || ''">
    <div class="col-header-title">{{header.text}}</div>
    <v-tooltip bottom v-if="header.legendText">
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <v-icon small :color="iconColor || ''">mdi-information-outline</v-icon>
        </span>
      </template>
      <span>{{header.legendText}}</span>
    </v-tooltip>
  </span>
</template>
<script>
export default {
  name: 'legend-icon',
  props: ['header', 'iconColor', 'rootClass'],
  data () {
    return {
    }
  }
}
</script>
<style scoped>
  .legend-row {
    display: flex;
  }
  .legend-row .col-header-title {
    margin-right: 3px;
  }
</style>



// WEBPACK FOOTER //
// LegendIcon.vue?796c13e7